import React from 'react'

import useCart from 'store/CartProvider'
import CartIcon from 'components/Icons/Cart'
import HeaderDropdown from './HeaderDropdown'
import HeaderCartItem from 'components/Header/components/HeaderCartItem'

const CartDropdown = ({ open, onClose }) => {
  const { products } = useCart()

  return (
    <HeaderDropdown
      open={open}
      onClose={onClose}
      title="ჩემი კალათა"
      items={products}
      emptyIcon={CartIcon}
      emptyTitle="კალათა ცარიელია"
      emptyMessage="გთხოვთ აირჩიოთ პროდუქცია"
      buttonText="ყიდვა"
      buttonRoute="/purchase"
      rightOffset="-right-6"
      tooltipRightOffset="right-[33px] md:right-[38px]"
      renderItem={product => <HeaderCartItem product={product} />}
    />
  )
}

export default CartDropdown
